module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("3vVFy"))).then(() => parcelRequire('jLPZF'));